import React from 'react';
import styled from 'styled-components';
import { getBranding } from 'utils/branding';
import { palette } from 'pages/AnyfitMall/theme';

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`;

const Header = styled.header`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
`;

const Logo = styled.img`
  width: 140px;
  height: auto;
  object-fit: contain;
`;

const ContentArea = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  /* sticky footer 공간 확보 + iOS 홈 인디케이터 영역 고려 */
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
`;

const StickyFooter = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  /* iOS 홈 인디케이터 영역만큼 bottom padding 추가 (viewport-fit=cover 필요) */
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  background-color: #ffffff;
`;

export const StickyLink = styled.a`
  display: block;
  width: 100%;
  background-color: ${palette.AnyBlue};
  color: ${palette.White};
  text-decoration: none;
  text-align: center;
  border-radius: 8px;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  font-family: 'Noto Sans KR', sans-serif;
  cursor: pointer;
  transition: background-color 0.2s ease;
  box-sizing: border-box;

  &:hover {
    background-color: #3a7ae8;
  }

  &:active {
    background-color: #2d6ad8;
  }
`;

/**
 * 케어센스 OAuth 전용 심플 레이아웃
 * - 햄버거 메뉴 없음
 * - 애니핏 로고 중앙 정렬 (Division 기반: B2B=프로, B2C=플러스)
 * - 하단 sticky 버튼 영역 지원
 * - 고정 높이로 레이아웃 시프트 방지
 */
const CaresenseLayout = ({ children, footer }) => {
  const branding = getBranding();

  return (
    <LayoutContainer>
      <Header>
        <Logo src={branding.logo} alt={branding.name} />
      </Header>
      <ContentArea>{children}</ContentArea>
      {footer && <StickyFooter>{footer}</StickyFooter>}
    </LayoutContainer>
  );
};

export default CaresenseLayout;
